import { ElMessage, ElMessageBox } from "element-plus";
import { ref } from "vue";
import { deleteMateriel } from "@/api/materiel";
export default function useManageEdit(getList) {
  // 编辑组件
  const editRef = ref(null);
  // 点击新增或编辑
  const handleEdit = (row, type) => {
    editRef.value?.handleDialogOpen({
      row,
      type,
    });
  };

  // 点击删除
  const handleDelete = (row) => {
    ElMessageBox.confirm(`确定删除物料【${row.name}】吗?`, "删除", {
      confirmButtonText: "删除",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteMateriel(row.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("删除成功");
            getList();
          }
        });
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  return { editRef, handleEdit, handleDelete };
}
